export function dataInRequest(params = {}) {
  return {
    type: '@turno/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@turno/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@turno/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@turno/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@turno/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@turno/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@turno/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@turno/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@turno/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@turno/RECORD_FILTERING',
    payload: { params },
  };
}

export function changePhysicalTankData(key, value) {
  return {
    type: '@turno/CHANGE_PHYSICAL_TANK_DATA',
    payload: { key, value },
  };
}

export function changeClosingData(key, value) {
  return {
    type: '@turno/CHANGE_CLOSING_DATA',
    payload: { key, value },
  };
}
